import {TaskInstructionType} from "@models/enums/task-instruction-type.enum";

export class TaskInstructionFileModel {
    public id: number;
    public rootPath: string;
    public fullPath: string;
    public type: TaskInstructionType

    constructor(file: any = {}) {
        this.id = file.id;
        this.rootPath = file.rootPath;
        this.fullPath = file.fullPath;
        this.type = this.getFileType(file.type);
    }

    getFileType(type) {
        switch (type) {
            case 1:
                return TaskInstructionType.WORK;
            case 2:
                return TaskInstructionType.SPARE;
            default:
                return null;
        }
    }
}
